export default "__VITE_ASSET__BDuvFSd___"